// import { CometChat } from "@cometchat-pro/chat";
import { CometChat } from '@cometchat/chat-sdk-javascript';
import { CometChatConversationsWithMessages, CometChatTheme, CometChatUIKit, CometChatUIKitConstants } from '@cometchat/chat-uikit-react';
import { TextBubbleStyle } from '@cometchat/uikit-elements';
import {
    CometChatUIKitUtility,
    ConversationsConfiguration,
    ConversationsStyle,
    MessageComposerConfiguration,
    MessageHeaderConfiguration,
    MessageListConfiguration,
    MessagesConfiguration,
    ThreadedMessagesConfiguration,
    WithMessagesStyle,
} from '@cometchat/uikit-shared';
import styled from '@emotion/styled';
import { Block, Delete } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Avatar, Button, Dialog, DialogContent, Divider, Menu, MenuItem, Typography, useMediaQuery } from '@mui/material';
import Badge from '@mui/material/Badge';
import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Context } from '../../App';
import ThreeDot from '../../assets/VectorMessenger.png';
import MessageSound from '../../assets/audio/notification-sound.mp3';
import { SHOP_CREATED } from '../../config/dataService/constants';
import { createUser } from '../../redux/CometChat/action';
import { customerDetail } from '../../redux/Customer/action';
import { getItem } from '../../utility/localStorage';
import './Messenger.css';
import NewChatList from './NewChatList';
import { COMET_CHAT_APP_ID, COMET_CHAT_AUTH_KEY } from '../../config/dataService/dataService';
import chatSendIcon from '../../assets/send-button.svg';
import { useTheme } from '@emotion/react';
import { refreshUnreadCount } from '../../utility/helpers/commonFunction';
import { LIVE_REACTION_ICON_URL } from './liveReactionIcon';

const MOBILE_VIEW_MAX_WIDTH = 769;

const getSubtitleView = (user) => {
    return <span style={{ color: '#347fb9', font: '400 11px Inter, sans-serif' }}>{user.role}</span>;
};

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            // animation: "ripple 1.2s infinite ease-in-out",
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));

const Messenger = () => {
    const { cometChatUser } = useContext(Context);

    const [openNewChatModel, setOpenNewChatModel] = React.useState(false);
    const dispatch = useDispatch();
    const [clickDisabled, setClickDisabled] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    const [user, setUser] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [templates, setTemplates] = useState([]);
    const shopDetail = getItem('apex-saas_details');
    // CometChat config objects are memoized: a new object on every render makes
    // the chat widget rebuild its whole conversation and message list.
    const cwmStyle = useMemo(
        () =>
            new WithMessagesStyle({
                // width: "500px",
                height: '90vh',
            }),
        []
    );
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showDeletePopup, setDeletePopup] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(null);

    // Only the mobile/desktop switch matters, so resizing within one layout does not re-render
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < MOBILE_VIEW_MAX_WIDTH);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < MOBILE_VIEW_MAX_WIDTH);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const cwfConfig = useMemo(
        () =>
            new ConversationsConfiguration({
                width: '456px',
                badgeStyle: {
                    background: 'red',
                },
                statusIndicatorStyle: { bottom: '5px', right: '5px' },
                avatarStyle: {
                    height: '64px',
                    width: '64px',
                    borderRadius: '50%',
                    backgroundColor: '#002394',
                    fontSize: '16px',
                    margin: '0 8px 0 16px !important',
                    nameTextFont: '400 12px Roboto',
                },
                listItemStyle: {
                    height: '96px',
                    background: 'white',
                    activeBackground: 'rgba(0, 102, 204, 0.078)',
                    hoverBackground: 'rgba(0, 102, 204, 0.078)',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.23)',
                    titleColor: '#000000DE',
                    padding: '16px',
                    titleFont: '600 17px Roboto',
                    separatorColor: 'rgba(0, 0, 0, 0.23)',
                },
                dateStyle: {
                    textFont: '400 17px Roboto',
                    padding: '4px 16px 4px 4px',
                },
                receiptStyle: {
                    marginTop: '8px !important',
                },
                conversationsStyle: new ConversationsStyle({
                    lastMessageTextColor: 'grey',
                }),
                customSoundForMessages: MessageSound,
                // titleAlignment: "center",

                menu: (
                    <Button
                        variant="contained"
                        onClick={(e) => setOpenNewChatModel(true)}
                        className="chatMOdule_newChatButton"
                        sx={{
                            width: '149px',
                            height: '42px',
                            padding: '8px 22px',
                            marginTop: '8px',
                        }}
                        startIcon={<AddIcon />}
                    >
                        NEW CHAT
                    </Button>
                ),
                // Replace your current onItemClick in cwfConfig:
                onItemClick: (conversation) => {
                    console.log('Conversation opened:', conversation);

                    const conversationWith = conversation.getConversationWith();
                    const conversationType = conversation.getConversationType();

                    if (conversationType === CometChat.RECEIVER_TYPE.USER) {
                        setUser(conversationWith);

                        // ✅ Update unread after a short delay to allow CometChat to mark messages read
                        setTimeout(() => {
                            refreshUnreadCount();
                        }, 2500);
                    }
                },
            }),
        []
    );

    const getCustomerType = async (id) => {
        setClickDisabled(true);
        const data = await dispatch(customerDetail(id));
        if (data) {
            if (data?.createdFrom == SHOP_CREATED) {
                navigate(`/customers/${id}/${SHOP_CREATED}`);
            } else {
                navigate(`/customers/${id}/apex_auto_app`);
            }
        }
        setClickDisabled(false);
    };

    const getMenu = (user) => {
        return (
            <div style={{ marginRight: '20px', cursor: 'pointer' }}>
                <img src={ThreeDot} onClick={(event) => setAnchorEl(event.currentTarget)} />
                <Menu
                    style={{ width: '80%' }}
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <MenuItem
                        onClick={() => {
                            setAnchorEl(null);
                            setDeletePopup(true);
                            setDeleteUserId(user?.uid);
                            // CometChat.deleteConversation(user?.uid, "user")
                            //   .then((deletedConversation) => {
                            //     navigate("/messenger");
                            //     window.location.reload();
                            //   })
                            //   .catch((error) => {
                            //     if (error?.code == "ERR_CONVERSATION_NOT_ACCESSIBLE") {
                            //       navigate("/messenger");
                            //       window.location.reload();
                            //     }
                            //   });
                        }}
                    >
                        <Delete style={{ marginRight: '10px' }} /> Delete Chat
                    </MenuItem>
                    <Divider />
                    <MenuItem
                        onClick={() => {
                            setAnchorEl(null);
                            CometChat.blockUsers([user?.uid]).then(
                                (list) => {
                                    console.log('users list blocked', { list });
                                    navigate('/messenger');
                                    window.location.reload();
                                },
                                (error) => {
                                    console.log('Blocking user fails with error', error);
                                }
                            );
                        }}
                        sx={{ color: '#D32F2F' }}
                    >
                        <Block color="error" style={{ marginRight: '10px' }} /> Block Customer
                    </MenuItem>
                </Menu>
            </div>
        );
    };
    // CometChat.unblockUsers(["664c810f7845211494a5ad4e"]).then(
    //   (list) => {
    //     console.log("users list blocked", { list });
    //   },
    //   (error) => {
    //     console.log("Blocking user fails with error", error);
    //   }
    // );
    const sendMessageApi = (val) => {
        console.log('🚀 ~ sendMessageApi ~ val:', val);

        // const options = {
        //   method: 'POST',
        //   headers: {
        //     accept: 'application/json', 'content-type': 'application/json',
        //     Authorization: `${COMET_CHAT_AUTH_KEY}`,
        //   },
        //   body: JSON.stringify({category: 'message', type: 'text'})
        // };

        // fetch(`https://${COMET_CHAT_APP_ID}.api-us.cometchat.io/v3/messages`, options)
        //   .then(response => response.json())
        //   .then(response => console.log('response--------------',response))
        //   .catch(err => console.error(err));
    };

    // const sendMessage = () => {
    //   let { receiverID, receiverType } = getReceiverDetails();
    //   let customData = {nudge: CUSTOM_MESSAGE_TYPE};

    //   const customMessage = new CometChat.CustomMessage(receiverID, receiverType, CUSTOM_MESSAGE_TYPE, customData);
    //   customMessage.setMetadata({ incrementUnreadCount: true });
    //   customMessage.setSentAt(CometChatUIKitUtility.getUnixTimestamp());
    //   customMessage.setMuid(CometChatUIKitUtility.ID());
    //   CometChatUIKit.sendCustomMessage(customMessage);
    // }

    // const getReceiverDetails = () => {

    //   if (props?.user?.uid) {
    //     return { receiverID: props.user.uid, receiverType: CometChatUIKitConstants.MessageReceiverType.user };

    //   } else if (props?.group?.guid) {
    //     return { receiverID: props.group.guid, receiverType: CometChatUIKitConstants.MessageReceiverType.group };
    //   }

    //   return {receiverID: "", receiverType: ""};
    // }

    // const sendButton = (user,messages) => {
    //  return (
    //     <cometchat-icon-button
    //     iconURL={chatSendIcon}
    //     text="Send Message"
    //     // dispatchClickEvent={COMET}
    //     >
    //     </cometchat-icon-button>
    //   )
    // };

    const sendButton = () => {
        return (
            <Button
                variant="contained"
                sx={{
                    width: '84px',
                    height: '42px',
                    padding: '8px 22px',
                    background: '#006CDD',
                    position: 'absolute',
                    bottom: '25px',
                    right: '40px',
                }}
            >
                SEND
            </Button>
        );
    };

    useEffect(() => {
        if (cometChatUser) {
            let definedTemplates = CometChatUIKit.getDataSource().getAllMessageTemplates(new CometChatTheme({}));
            const template = definedTemplates.map((template) => {
                if (template.type === 'text' && template.category === CometChatUIKitConstants.MessageCategory.message) {
                    template.contentView = (message) => getContentView(message);
                    return template;
                }
                return template;
            });
            setTemplates(template);
        }
    }, [cometChatUser]);

    const getContentView = (message) => {
        if (message instanceof CometChat.TextMessage) {
            const textStyle = new TextBubbleStyle({
                borderRadius: '6px',
                textFont: '400 16px Roboto',
                width: 'fit-content',
                background: message.sender.uid === shopDetail._id ? '#3d9fff' : '#f6f6f6eb',
                textColor: message.sender.uid === shopDetail._id ? 'rgb(255, 255, 255)' : '#000000de',
            });

            return (
                <cometchat-text-bubble
                    text={message.getText()}
                    textStyle={JSON.stringify(textStyle)}
                    style={{
                        display: 'flex',
                        textTransform: 'none',
                        justifyContent: message.receiver.name == shopDetail.shopName ? 'start' : 'end',
                    }}
                />
            );
        }
    };

    // Rebuilt only when state the header/menu views read changes (the menu needs anchorEl to open)
    const msConfig = useMemo(
        () =>
            new MessagesConfiguration({
                messageHeaderConfiguration: new MessageHeaderConfiguration({
                    showBackButton: true,
                    listItemView: (user, group) => {
                        return (
                            <div
                                onClick={() => {
                                    if (!clickDisabled) getCustomerType(user?.uid);
                                }}
                                style={{
                                    display: 'flex',
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    cursor: 'pointer',
                                    height: '96px',
                                    alignItems: 'center',
                                    // padding:'16px'
                                }}
                            >
                                {user.status == 'online' ? (
                                    <StyledBadge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot">
                                        <Avatar src={user?.avatar ?? ''} alt={user.name} sx={{ width: 64, height: 64 }}>
                                            {/* {user.name.split(" ")[0].charAt(0)}
              {user.name.split(" ")[1].charAt(0)} */}
                                        </Avatar>
                                    </StyledBadge>
                                ) : (
                                    <Avatar src={user?.avatar ?? ''} alt={user.name} sx={{ width: 64, height: 64, background: '#002394' }}>
                                        <span style={{ fontSize: '22px', fontWeight: '400' }}>
                                            {user?.name?.split(' ')[0]?.charAt(0)}
                                            {user?.name?.split(' ')[1]?.charAt(0)}
                                        </span>
                                    </Avatar>
                                )}
                                <div style={{ marginLeft: '16px', color: '#000000DE' }}>
                                    <span
                                        style={{
                                            fontWeight: 600,
                                            fontSize: '17px',
                                            lineHeight: '133.4%',
                                        }}
                                    >
                                        {user.name}
                                    </span>
                                    <br />
                                    {/* <span style={{ color: "#AFA6A7" }}>{user.status}</span> */}
                                </div>
                                {/* My profile view {user.name} */}
                            </div>
                        );
                    },
                    menu: (user) => getMenu(user),
                }),
                messageListConfiguration: new MessageListConfiguration({
                    messageListStyle: {
                        background: 'white',
                        TimestampTextFont: '400 10px Roboto',
                        textTransform: 'capitalize',
                    },
                    templates: templates,
                }),
                threadedMessageConfiguration: new ThreadedMessagesConfiguration({
                    messageListConfiguration: new MessageListConfiguration({
                        templates: templates,
                        messageListStyle: {
                            TimestampTextFont: '400 10px Roboto',
                        },
                    }),
                }),
                messageComposerConfiguration: new MessageComposerConfiguration({
                    // sendButtonView:(user,messages)=>sendButton(user,messages),
                    LiveReactionIconURL: LIVE_REACTION_ICON_URL,
                }),
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [anchorEl, clickDisabled, templates, navigate, dispatch]
    );

    // const urb = new CometChat.UsersRequestBuilder().setLimit(30).sortBy("status");
    const handleClose = () => {
        setOpenNewChatModel(false);
    };

    const createCustomerUser = async () => {
        const resp = await dispatch(
            createUser({
                customerId: id,
            })
        );
        CometChat.getUser(id)
            .then((res) => {
                setUser(res);
            })
            .catch((err) => {
                console.log('err', err);
            });
    };

    useEffect(() => {
        CometChat.getUser(id)
            .then((res) => {
                setUser(res);
            })
            .catch((err) => {
                console.log('err', err);
                createCustomerUser();
            });
    }, [id, cometChatUser]);

    return (
        <div>
            {/* <div className="messager_header_container">
        <Typography variant="h4" sx={{ fontWeight: 400 }}>
          Messenger
        </Typography>
      </div> */}
            {/* {cometChatUser && <CometChatUsersWithMessages />} */}
            <div className="chat_with_message_container">
                {cometChatUser && (
                    <CometChatConversationsWithMessages
                        // className='chat-custom-class'
                        conversationsConfiguration={cwfConfig}
                        conversationsWithMessagesStyle={cwmStyle}
                        messagesConfiguration={msConfig}
                        user={user}
                        isMobileView={isMobileView}
                    />
                )}
            </div>

            <NewChatList openNewChatModel={openNewChatModel} handleClose={handleClose} />

            {/* {cometChatUser && (
        <CometChatConversations
        
       
    
        />
      )} */}

            {/* {cometChatUser && (
        <CometChatUsers
          title="Contacts"
          hideSectionSeparator={true}
          showSectionHeader={false}
          searchIconURL="https://img.icons8.com/?size=24&id=vdK7simX78vX&format=png"
          usersRequestBuilder={urb}
          subtitleView={getSubtitleView}
          // listItemStyle={lStyle}
          // usersStyle={uStyle}
        />
      )} */}
            <Dialog fullScreen={false} open={showDeletePopup} className="delete-dialog" sx={{ borderRadius: '20px' }}>
                <DialogContent>
                    <Typography textAlign={'center'} fontSize={'22px'} fontWeight={500}>
                        Delete Conversation?
                    </Typography>
                    <Typography fontSize={'13px'} fontWeight={400} color={'rgba(20, 20, 20, 0.58)'} textAlign={'center'} mb={3}>
                        Would you like to delete this conversation? This conversation will be deleted from all of your devices.
                    </Typography>
                    <Button
                        onClick={async () => {
                            setDeletePopup(false);
                            CometChat.deleteConversation(deleteUserId, 'user')
                                .then((deletedConversation) => {
                                    navigate('/messenger');
                                    window.location.reload();
                                })
                                .catch((error) => {
                                    if (error?.code == 'ERR_CONVERSATION_NOT_ACCESSIBLE') {
                                        navigate('/messenger');
                                        window.location.reload();
                                    }
                                });
                            setDeleteUserId(null);
                        }}
                        fullWidth
                        variant="contained"
                        color="error"
                    >
                        Delete
                    </Button>
                    <Typography
                        textAlign={'center'}
                        sx={{
                            bgcolor: '#F9F9F9',
                            mt: '8px',
                            boxShadow: 'none',
                            width: '100%',
                            textAlign: 'center',
                            cursor: 'pointer',
                            height: '35px',
                        }}
                        onClick={() => {
                            setDeletePopup(false);
                            setDeleteUserId(null);
                        }}
                    >
                        Cancel
                    </Typography>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Messenger;
